import React, { useEffect, useRef, useState } from "react";
import "datatables.net-dt";
import "datatables.net-responsive-dt";
import $ from "jquery";
import { Link } from "react-router-dom";
import { PiPlusSquareFill } from "react-icons/pi";
import DeleteModel from "../../../components/admin/DeleteModel";
import api from "../../../config/URL";
import FreeThreshold from "./FreeThreshold";
import toast from "react-hot-toast";

const FreeCash = () => {
  const tableRef = useRef(null);
  const [datas, setDatas] = useState([]);
  const [thresholdData, setThresholdData] = useState({});
  const [loading, setLoading] = useState(false);
  const dataTableInstance = useRef(null);

  const initializeDataTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      return;
    }
    $(tableRef.current).DataTable({
      columnDefs: [{ orderable: false, targets: -1 }],
    });
  };

  useEffect(() => {
    if (!loading) {
      initializeDataTable();
    }
    return () => {
      destroyDataTable();
    };
  }, [loading]);

  const destroyDataTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
  };

  const refreshData = async () => {
    destroyDataTable();
    setLoading(true);
    try {
      const response = await api.get("/admin/freecoins");
      setDatas(response.data.data);
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
    setLoading(false);
    initializeDataTable();
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get("admin/freecoins");
        setDatas(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setLoading(false);
      initializeDataTable();
    };
    fetchData();
    refreshData();

    return () => {
      destroyDataTable();
      fetchData();
    };
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const fetchThreshold = async () => {
    try {
      const response = await api.get(`admin/freecoin/threshold`);
      setThresholdData(response.data.data);
    } catch (error) {
      toast.error("Error fetching threshold value");
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await api.get("/admin/freecoins");
      setDatas(response.data.data);
    } catch (error) {
      toast.error("Error fetching FreeCash data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchThreshold();
  }, []);

  useEffect(() => {
    if (!loading && datas.length > 0) {
      if (dataTableInstance.current) {
        dataTableInstance.current.destroy();
      }
      dataTableInstance.current = $(tableRef.current).DataTable({
        destroy: true,
        responsive: true,
        autoWidth: false,
        columnDefs: [{ orderable: false, targets: -1 }],
      });
    }
  }, [loading, datas]);

  return (
    <section className="px-4">
      <div className="card shadow border-0 mb-2 top-header">
        <div className="container-fluid py-1">
          <div className="row align-items-center">
            <div className="col p-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <h3 className="mb-0 ls-tight text-nowrap">Free Cash</h3>&nbsp;
                  (Threshold Value: {thresholdData?.value || "--"}%){" "}
                  <FreeThreshold onUpdated={fetchThreshold} />
                </div>
                <div className="d-flex justify-content-end">
                  <Link to="/freeCash/add">
                    <button className="btn btn-sm btn-button shadow-none border-none py-3">
                      <PiPlusSquareFill size={20} /> Add Free Cash
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container card shadow border-0"
        style={{ minHeight: "80vh" }}
      >
        {loading ? (
          <div className="loader-container">
            <div className="loader">
              <svg viewBox="0 0 80 80">
                <circle cx="40" cy="40" r="32"></circle>
              </svg>
            </div>
          </div>
        ) : (
          <div className="table-responsive p-2">
            <table
              ref={tableRef}
              className="display table nowrap"
              style={{ width: "100%" }}
            >
              <thead className="thead-light">
                <tr>
                  <th scope="col" style={{ whiteSpace: "nowrap" }}>
                    S.NO
                  </th>
                  <th className="text-start">Event Key</th>
                  <th className="text-start">Event Name</th>
                  <th className="text-start">Rewards Amount</th>
                  <th className="text-start">Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {datas?.map((data, index) => (
                  <tr key={data.id}>
                    <td className="text-start align-middle">{index + 1}</td>
                    <td className="text-start align-middle">
                      {data.event_key.replace(/_/g, " ")}
                    </td>
                    <td className="text-start align-middle">
                      {data.event_name}
                    </td>
                    <td className="text-start align-middle">
                      ₹{data.reward_amount}
                    </td>
                    <td className="text-start align-middle">
                      {data.is_active ? (
                        <span className="badge bg-success">Active</span>
                      ) : (
                        <span className="badge bg-danger">Inactive</span>
                      )}
                    </td>
                    <td className="align-middle text-center">
                      <Link to={`/freeCash/edit/${data.id}`}>
                        <button className="button-btn btn-sm m-2">Edit</button>
                      </Link>
                      {/* Uncomment if you want to include the View button */}
                      <Link to={`/freeCash/view/${data.id}`}>
                        <button className="button-btn btn-sm m-2">View</button>
                      </Link>
                      {/* Uncomment and implement DeleteModel if needed */}
                      <DeleteModel
                        onSuccess={refreshData}
                        path={`/admin/freecoins/${data.id}`}
                        style={{ display: "inline-block" }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default FreeCash;
